import { render, staticRenderFns } from "./ResultArea.vue?vue&type=template&id=28fac44f"
import script from "./ResultArea.vue?vue&type=script&lang=js"
export * from "./ResultArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports